<template>
  <div class>
    <div class="Home">
      <div class="oldBrowser">
        <h2>Sie verwenden einen alten Browser! Die Funktionalität kann nicht gewährleistet werden.</h2>
        <h3>Bitte verwenden Sie einen mordernen Browser wie: Edge, Firefox oder Chrome</h3>
      </div>
      <div>
        <h1 style="font-size: 150%;">Herzlich willkommen!</h1>
      </div>
      <v-divider></v-divider>
      <br>
      <p>
        Diese Website wurde im Zuge einer Diplomarbeit an der
        <strong>Höheren technischen Bundeslehr- und Versuchsanstalt Innsbruck Anichstraße</strong>
        erstellt und bietet Betriebsleiterinnen und Betriebsleitern von Seilbahnanlagen die Möglichkeit,
      </p>
      <h2>die Bestimmung der Intervalle für die Sichtprüfung an Seilen</h2>
      <p>gemäß ÖNORM EN 12927:2019 (Anhang E) durchzuführen.</p>
      <p>
        Diese App führt Sie Schritt für Schritt durch die einzelnen Fragestellungen und unterstützt Sie durch
ergänzende Erklärungen in der Vergabe der Punkte. Es wird darauf hingewiesen, dass die
Berechnungsergebnisse nicht rechtsverbindlich und die Vorgaben des Seilherstellers sowie der
Seilbahnbehörde zu beachten sind.
      </p>
      <div v-if="this.$store.state.isOnline">
        <v-btn
          @click="start"
          block
          color="blue"
          large
          class="startBtn"
          style="color: white;"
        >{{btnName}}</v-btn>
      </div>
      <div v-if="!this.$store.state.isOnline">
        <p style="color: blue">Bitte registrieren Sie sich, um diese App zu nutzen!</p>
        <v-container>
          <v-layout row wrap>
            <v-flex>
              <v-btn
                color="blue"
                style="font-size: 110%; color: white"
                @click="goToRegister"
              >Registrieren</v-btn>
            </v-flex>
            <v-flex>
              <v-btn color="blue" style="font-size: 110%; color: white" @click="goToLogin">Anmelden</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
      <v-divider></v-divider>
      <v-container>
        <v-layout>
          <v-flex>
            <!-- <img :src="'statics/images/WuerfellogoKlein.jpg'" class="dice"> -->
            <v-img :src="require('../statics/images/WuerfellogoKlein.jpg')" width="50%" position="center" class="dice"></v-img>
          </v-flex>
          <!-- <v-flex>
            <h4>HTL-Anichstraße</h4>
             <v-img :src="require('../statics/images/HTL.png')" class="imgHTL" @click="goToHTL"></v-img>
          </v-flex>

          <v-flex style="margin: 0% auto 0% auto;;">
            <h4>Versuchsanstalt</h4>
            <img :src="require('../statics/images/VAM-Logo.gif')" class="imgVAM" @click="goToVAM">
          </v-flex> -->
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  userOnline: false,
  name: "Home",
  classOff: "HomeOffline",
  classOn: "HomeOnline",
  data() {
    return {
      btnName: ""
    };
  },
  methods: {
    start() {
      this.$router.push("Facilities");
    },
    goToLogin() {
      this.$router.push("Login");
    },
    goToRegister() {
      this.$router.push("Register");
    },
    goToHTL() {
      window.location.href = "https://htl-anichstrasse.tirol/";
    },
    goToVAM() {
      window.location.href = "https://www.vamibk.at";
    }
  },
  created() {
    this.userOnline = this.$store.state.isonline;
    if (this.$store.state.isOnline) {
      this.btnName = "Start";
    } else {
      this.btnName = "Anmelden";
    }
  }
};
</script>

<style>
.Home {
  background-color: white;
  width: 80%;
  margin: 0.5% auto 0% auto;
  border: 5px solid black;
  border-radius: 5px;
  padding: 0% 2% 0% 2%;
  text-align: center;
  font-size: 150%;
  color: black;
  opacity: 0.85;
  filter: alpha(opacity=85);
  /* text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black; */
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .Home {
        font-size: 80%;
    }
}

.oldBrowser {
  display: none;
  background-color:red;
  color: white;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
   .oldBrowser{display: block}
}

.HomeOnline {
  background-color: white;
  width: 70%;
  margin: 2% auto 0% auto;
  border: 5px solid black;
  border-radius: 5px;
  padding: 0% 2% 0% 2%;
  text-align: center;
  font-size: 150%;
  color: black;
  opacity: 0.85;
  filter: alpha(opacity=85);
  /* text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black; */
}

/* .startBtn {
  color: white;
  font-size: 110%;
} */

.imgHTL {
  width: 85px;
  height: 85px;
}

.imgVAM {
  /* height: 70%; */
  width: 50%;
}

@media (max-width: 800px) and (orientation: landscape) {
  .imgHTL {
    width: 50px;
    height: 50px;
    margin-left: auto;
    margin-right: auto;
  }

  .imgVAM {
    height: 80%;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }
}

/*
@media (min-width: 1000px) {
  .startBtn {
    color: white;
    font-size: 110%;
  }
} */

.HomeBorder {
  background-color: black;
}

.startBtn {
  color: white;
  font-size: 110%;
}

.otherWebsites {
  margin: 0% auto 0% auto;
}

.dice{
  height: 90%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
